<template>
  <div class="loading rotate-loading" :style="loadingStyle">
    <img :src="Loading" alt="">
  </div>
</template>
<script lang="ts" setup>
import LoadingBlack from '@/assets/image/loading-black.svg';
import LoadingWhite from '@/assets/image/loading-white.svg';
import { reactive, computed, defineExpose } from 'vue';

// 一般height width 都是等比
const styleInfo = reactive<{
  width: string;
  height: string;
  colorType: 'white' | 'black';
}>({
  height: '20px',
  width: '20px',
  colorType: 'white',
})


const loadingStyle = computed(() => {
  return {
    height: styleInfo.height,
    width: styleInfo.width,
    marginRight: '8px',
    color: 'black',
  }
});
const Loading = computed(() => {
  return styleInfo.colorType === 'black' ? LoadingBlack : LoadingWhite;
});


const changeInfo = (size: string, colorType: 'white' | 'black') => {
  if (size) {
    styleInfo.width = size;
    styleInfo.height = size;
  }
  colorType && (styleInfo.colorType = colorType);
}

defineExpose<{
  changeInfo: (size: string, colorType: 'white' | 'black') => any;
}>({
  changeInfo,
})
</script>
<style lang="less" scoped>
  .loading{
    width: 100%;
    height: 100%;
  }
  img {
    height: 100%;
    width: 100%;
    display: block;
  }
</style>
